import { render, staticRenderFns } from "./NewFranchiseSidebar.vue?vue&type=template&id=4b4cb7ff&scoped=true"
import script from "./NewFranchiseSidebar.vue?vue&type=script&lang=js"
export * from "./NewFranchiseSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewFranchiseSidebar.vue?vue&type=style&index=0&id=4b4cb7ff&prod&lang=scss&scoped=true"
import style1 from "./NewFranchiseSidebar.vue?vue&type=style&index=1&id=4b4cb7ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cb7ff",
  null
  
)

export default component.exports